import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\Atlas\AltoController::update
* @see app/Http/Controllers/Company/Atlas/AltoController.php:32
* @route '/companies/{company}/atlas/alto'
*/
export const update = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/companies/{company}/atlas/alto',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Company\Atlas\AltoController::update
* @see app/Http/Controllers/Company/Atlas/AltoController.php:32
* @route '/companies/{company}/atlas/alto'
*/
update.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return update.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\Atlas\AltoController::update
* @see app/Http/Controllers/Company/Atlas/AltoController.php:32
* @route '/companies/{company}/atlas/alto'
*/
update.put = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Company\Atlas\AltoController::destroy
* @see app/Http/Controllers/Company/Atlas/AltoController.php:54
* @route '/companies/{company}/atlas/alto'
*/
export const destroy = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/companies/{company}/atlas/alto',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Company\Atlas\AltoController::destroy
* @see app/Http/Controllers/Company/Atlas/AltoController.php:54
* @route '/companies/{company}/atlas/alto'
*/
destroy.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return destroy.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\Atlas\AltoController::destroy
* @see app/Http/Controllers/Company/Atlas/AltoController.php:54
* @route '/companies/{company}/atlas/alto'
*/
destroy.delete = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const alto = {
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default alto